import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export const currencyMask = createNumberMask({
  prefix: '$ ',
  allowDecimal: true,
  integerLimit: 10,
});

export const confirmAmountOfSaleMask = createNumberMask({
  prefix: '$ ',
  allowDecimal: true,
  integerLimit: 5,
  maxValue: 100,
  minValue: 0,
});

export const numberMask = createNumberMask({
  prefix: '',
  thousandsSeparatorSymbol: '',
  allowLeadingZeroes: true,
});

export function unmask(val) {
  return `${val}`.replace(/[$, ]+/g, '');
}

export function numberUnmask(val) {
  const numbers = `${val}`.match(/\d+/g);
  return numbers ? numbers.join('') : '';
}

export const formatPhone = (num) => {
  if (!num) return '';
  const digits = num.replace(/\D/g, '');
  if (digits.length !== 10) return num;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export function floatUnmask(val) {
  const numbers = `${val}`.match(/[\d.]+/g);
  return numbers ? numbers.join('') : 0;
}

export function removeSpace(str) {
  return `${str}`.replace(/\s+/g, '');
}

export function removeUnderline(str) {
  return `${str}`.replace(/_+/g, '');
}

export function unmaskCurrency(val) {
  return `${val}`.replace(/[$, ]+/g, '');
}

export const cardNumberMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const cardNumberLast4Mask = ['*', '*', '*', '*', '-', '*', '*', '*', '*', '-', '*', '*', '*', '*', '-', /\d/, /\d/, /\d/, /\d/];

export const ssnLast4Mask = [/\d/, /\d/, /\d/, /\d/];
